<template>
  <div class="container mt-5">
    <button class="btn btn-outline-secondary mb-4" @click="goBack">
      <font-awesome-icon icon="arrow-left" class="me-2" />
      {{ $t("common.back") }}
    </button>

    <!-- Steps 2 and 3 (needs and plan) run in the dashboard's onboarding modal right after this form. -->
    <OnboardingStepsComponent
      current="company"
      class="onboarding-steps mx-auto mb-5"
    />

    <div class="text-center mb-5">
      <h1 class="page-title font-serif mb-3">
        {{ $t("signup.corporate.title") }}
      </h1>
      <p class="lead text-body-secondary mx-auto subtitle">
        {{ $t("signup.corporate.description") }}
      </p>
    </div>

    <CorporateCompanyForm
      :company="companyData"
      :loading="loading"
      @submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import OnboardingStepsComponent from "@/billing/OnboardingStepsComponent.vue";
import { useCorporateSignup } from "@/signup/composables/useCorporateSignup";
import CorporateCompanyForm from "@/signup/corporate/CorporateCompanyForm.vue";
import { signupApi } from "@/signup/signupApi";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useGlobalHandlers } from "@/composables/useGlobalHandlers";

const router = useRouter();
const { globalErrorHandler } = useGlobalHandlers();
const { companyData, loading, createCompany } = useCorporateSignup();

const goBack = () => {
  router.push("/signup");
};

const handleSubmit = async (data: any) => {
  try {
    const result = await createCompany(data);
    router.push(`/dashboard?company_id=${result.company_id}`);
  } catch {
    // createCompany already reports the error (with a specific message for the
    // company-creation rate limit); re-reporting here would overwrite it.
  }
};

onMounted(() => {
  signupApi
    .setOnboardingStep("CORPORATE")
    .catch((error) => globalErrorHandler(error));
});
</script>

<style scoped lang="scss">
.onboarding-steps {
  max-width: 600px;
}

.page-title {
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.subtitle {
  max-width: 600px;
}
</style>
